import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import SearchListViewViewModel from '@/ViewModels/Views/SearchListViewViewModel';
import SearchListViewView from '@/Views/SearchListViewView';

export default class SearchListViewViewFactory extends ViewFactory {

    /**
     * @override
     */
    public viewModel: SearchListViewViewModel;

    constructor(params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Modal';
    }

    /**
     * @override
     */
    public getView() {
        var searchListViewViewModel = ComponentManager.getViewModel<typeof SearchListViewViewModel>('SearchListViewViewModel');
        var searchListViewView = ComponentManager.getView<typeof SearchListViewView>('SearchListViewView');

        if (this.viewModel == null) {
            this.viewModel = new searchListViewViewModel({ viewFactory: this });
        }

        if (this.view == null) {
            this.view = new searchListViewView(this.viewModel, this.createRootElement('SearchListView'));
        }

        var tuple = this.view.getTuple();
        return tuple.view;
    }

}

ComponentManager.setFactory('SearchListView', SearchListViewViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');